export default __webpack_public_path__ + "static/media/letter-1.1e8a6b61.png";